var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.961,
    height: 74.944,
    viewBox: "0 0 75.961 74.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "united-kingdom",
    transform: "translate(0.435)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2741",
    "data-name": "Ellipse 2741",
    cx: 37.981,
    cy: 37.326,
    rx: 37.981,
    ry: 37.326,
    transform: "translate(-0.435)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46497",
    "data-name": "Group 46497",
    transform: "translate(1.426 1.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54007",
    "data-name": "Path 54007",
    d: "M15.274,100.142a37.335,37.335,0,0,0-6.455,13.039H28.313Z",
    transform: "translate(-8.819 -86.775)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54008",
    "data-name": "Path 54008",
    d: "M389.5,113.182a37.338,37.338,0,0,0-6.455-13.039l-13.038,13.039Z",
    transform: "translate(-317.136 -86.775)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54009",
    "data-name": "Path 54009",
    d: "M8.819,322.784a37.339,37.339,0,0,0,6.455,13.038l13.038-13.038Z",
    transform: "translate(-8.819 -276.827)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54010",
    "data-name": "Path 54010",
    d: "M335.821,15.274a37.338,37.338,0,0,0-13.039-6.455V28.313Z",
    transform: "translate(-276.825 -8.819)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54011",
    "data-name": "Path 54011",
    d: "M100.142,383.043a37.338,37.338,0,0,0,13.039,6.455V370.005Z",
    transform: "translate(-86.775 -317.136)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54012",
    "data-name": "Path 54012",
    d: "M113.18,8.819a37.339,37.339,0,0,0-13.038,6.455L113.18,28.313Z",
    transform: "translate(-86.775 -8.819)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54013",
    "data-name": "Path 54013",
    d: "M322.783,389.5a37.339,37.339,0,0,0,13.038-6.455l-13.038-13.038Z",
    transform: "translate(-276.826 -317.136)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54014",
    "data-name": "Path 54014",
    d: "M370.005,322.784l13.038,13.039a37.338,37.338,0,0,0,6.455-13.039Z",
    transform: "translate(-317.136 -276.827)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46498",
    "data-name": "Group 46498",
    transform: "translate(0.135 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54015",
    "data-name": "Path 54015",
    d: "M74.627,32.585H42.36V.317a37.816,37.816,0,0,0-9.775,0V32.584H.317a37.816,37.816,0,0,0,0,9.775H32.584V74.627a37.817,37.817,0,0,0,9.775,0V42.36H74.627a37.817,37.817,0,0,0,0-9.775Z",
    transform: "translate(0 0)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54016",
    "data-name": "Path 54016",
    d: "M322.783,322.783,339.5,339.5q1.154-1.153,2.2-2.406l-14.316-14.316h-4.608Z",
    transform: "translate(-275.535 -275.535)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54017",
    "data-name": "Path 54017",
    d: "M91.7,322.784h0L74.98,339.505q1.153,1.153,2.406,2.2L91.7,327.392Z",
    transform: "translate(-64.005 -275.536)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54018",
    "data-name": "Path 54018",
    d: "M78.857,91.7h0L62.136,74.98q-1.154,1.153-2.2,2.406L74.249,91.7h4.608Z",
    transform: "translate(-51.16 -64.005)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54019",
    "data-name": "Path 54019",
    d: "M322.783,78.858,339.5,62.137q-1.153-1.154-2.406-2.2L322.783,74.25Z",
    transform: "translate(-275.535 -51.161)",
    fill: "#d80027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreUk);
export default __webpack_public_path__ + "static/media/explore-uk.7ad5e17637272c7629fd770bd24b5416.svg";
export { ForwardRef as ReactComponent };